module.exports = __webpack_public_path__ + "img/main-dec_m.051f459c.jpg";